<template>
    <div class="mbody">
        <h1 style="justify-content: center;display: flex;">On Sale NFTs</h1>

        <hr class="rounded">
        <CoalDialog></CoalDialog>


        <!-- <div class="genholder genholderh">

            <button @click="seeker -= 10">Back</button>
            <div class="centex">{{ seeker }} - {{ seeker + 20 }}</div>
            <button @click="seeker += 10">Forward</button>
        </div> -->

        <!-- <div class="genholder genholderh">

            <button @click="seeker -= 20; $store.state.view_list_last_seeker = this.seeker">Back</button>
            <div class="centex"><input class="mytex mytexredbord" v-model="seeker_text"
                    @keyup.enter="edit_mode_enable = false; seeker_data = parseInt(seeker_text); reload()"
                    v-show="edit_mode_enable == true" type="text" /><button v-show="edit_mode_enable == false"
                    @click="edit_mode_enable = true; seeker_text = seeker_data + ''">{{ seeker }} - {{ seeker + 20
                    }}</button></div>
            <button @click="seeker += 20; $store.state.view_list_last_seeker = this.seeker">Forward</button>
        </div> -->
        <div class="genholder genholderv">

            <div style="text-align: center" v-show="!is_loading && loaded_nfts.length == 0">Nothing on sale !!!</div>
            <table class="wbord" v-show="loaded_nfts.length > 0">
                <tr class="wbord">
                    <th class="wbord">ID</th>
                    <th class="wbord">Atrribs</th>
                    <th class="wbord">Strength</th>
                    <th class="wbord">Price $KDA</th>
                    <!-- <th class="wbord">on sale?</th> -->
                    <!-- <th class="wbord">sale until</th> -->
                    <th class="wbord">Owner</th>
                    <th class="wbord">Minter</th>
                    <th class="wbord">Mint Date</th>
                </tr>
                <tr class="wbord" v-bind:class="nft.is_owned_by_wallet() ? 'ownerclass' : 'notownerclass'"
                    v-show="!is_loading" v-for="(nft, nftidx) in loaded_nfts" :key="nftidx">
                    <td> {{ nft.get_id() }}</td>
                    <td class="coalrendcls">
                        <CoalRend style="transform: scale(0.7);" :nft="nft"></CoalRend>
                    </td>
                    <td> {{ nft.get_strength() }} / 256 </td>
                    <td>
                        <button @click="buy_nft(nft)" v-show="nft.get_sale_state() && !nft.is_owned_by_wallet()">
                            {{ nft.get_price()
                            }} <span v-show="nft.get_sale_state()" class="buybutt" style="margin-left: 2%;">
                                buy
                                <LoadingComp v-show="buy_loading[nft.get_id()] == true"></LoadingComp>
                            </span>
                        </button>
                        <div v-show="nft.get_sale_state() && nft.is_owned_by_wallet()">{{ nft.get_price()
                        }} </div>
                    </td>
                    <!-- <td> {{ nft["on-sale"] ? 'yes' : 'no' }}</td> -->
                    <!-- <td> {{ nft["sale-timeout"] < 0 ? 'always' : nft["sale-timeout"] }}</td> -->
                    <td> {{ nft.get_owner() }}</td>
                    <td> {{ nft.get_minter() }}</td>
                    <td> {{ nft.get_date_formatted() }}</td>
                </tr>
            </table>
            <LoadingComp v-show="is_loading"></LoadingComp>

        </div>

    </div>
</template>

<script>
import LoadingComp from '../LoadingComp.vue';
import CoalDialog from './CoalDialog.vue';
import CoalRend from './CoalRend.vue';
import ENUMS from '../Enums';
import { get_nft_strength_from_hash, date_formatter, transfer_cap_maker, get_nft_manager, get_account } from '@/utility'


export default {
    name: ENUMS.VIEWS.LISTONSALE
    , data() {
        return {
            ENUMS: ENUMS
            , loading: true
            , loaded_nfts: []
            , buy_loading: {}
            , seeker_data: 0
            , edit_mode_enable: false
            , seeker_text: 0
            , dialog_message: undefined
        };
    }
    , computed: {
        is_loading() {
            return this.loading
        }
        , seeker: {
            set: function (x) {
                var entervalue = this.seeker_data
                this.seeker_data = Math.min(x, 6950)
                this.seeker_data = Math.max(x, 0)
                if (entervalue != this.seeker_data) {
                    this.loading = true
                    this.reload()

                }
            }, get: function () {
                return this.seeker_data
            }
        }
    }
    , mounted() {
        this.reload()

    }
    , methods: {
        reload() {
            var qthis = this
            get_nft_manager(qthis).then(x => x.load_on_sale()).then(x => {
                qthis.loaded_nfts = x.get_nfts()
                qthis.loading = false
            }).finally(() => {
                qthis.loading = false

            })

        }, buy_nft(nft) {
            var qthis = this
            this.buy_loading[nft.get_id()] = true
            nft.buy_nft().catch(e => {
                // TODO bad buy
                qthis.buy_loading[nft.get_id()] = false
                qthis.dialog_message = "rejected by user"

                throw e
            }
            ).then((x) => {
                // TODO success buy
                console.log(x)
                get_account(this).then(acc => {
                    if (Object.values(x)[0].result.data.owner == acc.name) {
                        qthis.dialog_message = "bought NFT #id : " + nft.get_id() + " for " + Object.values(x)[0].result.data["last-sale-price"] + " KDA"
                    }
                    // qthis.$store.state.current_view = ENUMS.VIEWS.MYNFTS
                    qthis.reload()

                }).finally(() => {
                    qthis.buy_loading[nft.get_id()] = false
                })
            }).finally(() => {
                qthis.loading = false

            })

        }
        , get_nft_strength_from_hash: get_nft_strength_from_hash
        , date_formatter: date_formatter
        , transfer_cap_maker: transfer_cap_maker
    }
    , components: { LoadingComp, CoalRend, CoalDialog }
}

</script>

<style scoped>
tr:hover {
    background-color: rgb(99, 0, 0);
}

/* td:hover{
    background-color: rgb(124, 0, 0);
} */

tr:hover:nth-child(1) {
    background-color: black
}

td>button:hover {
    background-color: rgb(124, 0, 0);

}

.buybutt {
    color: greenyellow;
}

.ownerclass {
    background-color: rgb(34, 34, 34);
}
</style>